(function(){
  // header state
  var header=document.getElementById('siteHeader');
  function onScroll(){ if(window.scrollY>40){header.classList.add('scrolled');} else {header.classList.remove('scrolled');} }
  window.addEventListener('scroll',onScroll,{passive:true}); onScroll();

  // mobile nav
  var toggle=document.getElementById('navToggle'), nav=document.getElementById('mobileNav');
  if(toggle){ toggle.addEventListener('click',function(){
    var open=nav.classList.toggle('open');
    nav.style.display='flex';
    if(!open){ setTimeout(function(){nav.style.display='none';},450); }
    toggle.setAttribute('aria-expanded',open);
    document.body.style.overflow=open?'hidden':'';
  }); }

  // reveal on scroll (position check, robust to fast flings)
  function revealCheck(){
    var vh=window.innerHeight;
    document.querySelectorAll('.reveal:not(.in)').forEach(function(el){
      if(el.getBoundingClientRect().top < vh*0.94){ el.classList.add('in'); }
    });
  }
  var rTick=false;
  window.addEventListener('scroll',function(){ if(!rTick){ requestAnimationFrame(function(){revealCheck();rTick=false;}); rTick=true; } },{passive:true});
  revealCheck();

  // gentle parallax
  var px=[].slice.call(document.querySelectorAll('[data-parallax]'));
  if(px.length && !window.matchMedia('(prefers-reduced-motion: reduce)').matches){
    var ticking=false;
    function par(){
      px.forEach(function(el){
        var r=el.parentElement.getBoundingClientRect();
        var prog=(r.top+r.height/2-window.innerHeight/2)/window.innerHeight;
        el.style.transform='translateY('+(prog*-7)+'%)';
      });
      ticking=false;
    }
    window.addEventListener('scroll',function(){ if(!ticking){ requestAnimationFrame(par); ticking=true; } },{passive:true});
    par();
  }

  // hero fallback: swap a paused video for the poster when autoplay is blocked (e.g. iOS Low Power Mode)
  var hv=document.querySelector('.hero-media video');
  if(hv){
    var heroZoom=function(el){ if(!window.matchMedia('(prefers-reduced-motion: reduce)').matches){ el.animate([{transform:'scale(1.12)'},{transform:'scale(1.0)'}],{duration:6000,easing:'cubic-bezier(.22,1,.36,1)',fill:'forwards'}); } };
    var swapToPoster=function(){ if(!hv.isConnected){return;} var img=document.createElement('img'); img.src=hv.getAttribute('poster'); img.alt=''; hv.replaceWith(img); heroZoom(img); };
    var hvPlayed=false;
    hv.addEventListener('playing',function(){ hvPlayed=true; });
    hv.addEventListener('error',swapToPoster);
    var tryPlay=hv.play();
    if(tryPlay && tryPlay.catch){ tryPlay.catch(swapToPoster); }
    setTimeout(function(){ if(!hvPlayed && hv.paused){ swapToPoster(); } },1500);
  }

  // hero slow zoom
  var hm=document.querySelector('.hero-media video, .hero-media img');
  if(hm && !window.matchMedia('(prefers-reduced-motion: reduce)').matches){
    hm.animate([{transform:'scale(1.12)'},{transform:'scale(1.0)'}],{duration:6000,easing:'cubic-bezier(.22,1,.36,1)',fill:'forwards'});
  }
})();
